import React from "react";
import Preloader from "../helper/Preloader";
import SaleOfferTwo from "../components/SaleOfferTwo";
import HeaderOne from "../components/HeaderOne";
import BannerTwo from "../components/BannerTwo";
import PopularTwo from "../components/PopularTwo";
import SellingTwo from "../components/SellingTwo";
import ArrivalTwo from "../components/ArrivalTwo";
import FeaturedTwo from "../components/FeaturedTwo";
import ServiceOne from "../components/ServiceOne";
import Testimonial from "../components/Testimonial";
import PricingOne from "../components/PricingOne";
import BrandSectionTwo from "../components/BrandSectionTwo";
import BecomeSellerTwo from "../components/BecomeSellerTwo";
import BlogTwo from "../components/BlogTwo";
import ResourceOne from "../components/ResourceOne";
import Newsletter from "../components/Newsletter";
import FooterTwo from "../components/FooterTwo";


const HomePageTwo = () => {
  
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* SaleOfferTwo */}
      <SaleOfferTwo />

      {/* HeaderOne */}
      <HeaderOne />

      {/* BannerTwo */}
      <BannerTwo />

      {/* PopularTwo */}
      <PopularTwo />

      {/* SellingTwo */}
      <SellingTwo />

      {/* ArrivalTwo */}
      <ArrivalTwo />

      {/* FeaturedTwo */}
      <FeaturedTwo />

      {/* ServiceOne */}
      <ServiceOne />

      {/* Testimonial */}
      <Testimonial />

      {/* PricingOne */}
      <PricingOne />

      {/* BrandSectionTwo */}
      <BrandSectionTwo />

      {/* BecomeSellerTwo */}
      <BecomeSellerTwo />

      {/* BlogTwo */}
      <BlogTwo />

      {/* ResourceOne */}
      <ResourceOne />

      {/* Newsletter */}
      <Newsletter />

      {/* FooterTwo */}
      <FooterTwo />
    </>

  );
};

export default HomePageTwo;
